import type { DecisioningCreativeComponentTriggerPropertiesHash } from "./types";

/**
 * Narrows a test-send trigger properties payload to the DS creative-component shape.
 * Canvas and custom-user payloads may include additional top-level keys.
 */
export const isDecisioningCreativeComponentTriggerPropertiesHash = (
  value: DecisioningCreativeComponentTriggerPropertiesHash | Record<string, unknown>
): value is DecisioningCreativeComponentTriggerPropertiesHash => {
  return "api_trigger_properties" in value && !("canvas_entry_properties" in value);
};
